module.exports = __webpack_public_path__ + "static/media/goblin_bomber_circle.2a4b1616.svg";